import {
  getReq,
  END_POINTS
} from '@/api'
// import * as dayjs from 'dayjs'
// import * as Lodash from 'lodash'
import * as Utils from '@/utils'
import * as StoreUtils from '@/utils/StoreUtils'

const state = {
  // pdCostColumnDDStore: {
  //   list: [],
  //   map: {}
  // },
  END_STATE: null
}

const getters = {

}

const actions = {
  ...StoreUtils.actions,
  findPdCostColumnDDList({
    commit,
    state,
    rootState
  }) {
    return new Promise((resolve, reject) => {
      getReq(END_POINTS.FIND_PD_COST_COLUMN_DD_LIST)
        .then(res => {
          if (res.success) {
            const DDStore = Utils.getDDStore(res.data)
            // Utils.copyDDStore(DDStore, state.pdCostColumnDDStore)
            resolve(DDStore)
          } else {
            StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
          }
        }).catch(err => {
          reject(err)
        })
    })
  },
  END_ACTIONS() {}
}

const mutations = {
  ...StoreUtils.mutations,
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/conf/pdCostColumnManage.js